import { ModuleRoute } from 'module-routes';

export enum DashboardPath {
  Home = '',
}

export const DashboardModuleRoutes = new Map<DashboardPath, <T>(id?: T) => string>([
  [DashboardPath.Home, () => `${ModuleRoute.Dashboard}/${DashboardPath.Home}`],
]);

export const getDashboardModuleRoutes = <T>(route: DashboardPath, id?: T): string => {
  const routeFunction = DashboardModuleRoutes.get(route);
  if (routeFunction) {
    return routeFunction(id);
  }
  throw new Error(`Route ${route} not found}`);
};
